import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { SubscriptionName } from '../../../types/subscription.type';
import { formatDate, handleDifferenceInDays, handleSubscriptionName } from './helpers.subscription';
import { theme } from './theme';
var DAYS_TO_SHOW_WARNING_ALERT = 10;
var AlertComponent = lazy(function () { return import('../../UIcomponents/AlertComponent/AlertComponent'); });
var SubscriptionInfo = function (_a) {
    var expirationDate = _a.expirationDate, subscriptionName = _a.subscriptionName;
    var t = useTranslation('settings').t;
    var dateDifference = handleDifferenceInDays(expirationDate);
    var isInfoAlert = dateDifference >= DAYS_TO_SHOW_WARNING_ALERT;
    var isTrialSubscription = subscriptionName === SubscriptionName.Trial;
    var subscriptionMessage = isTrialSubscription
        ? "".concat(t('subscription.alert.infoParagraph1'), " ").concat(handleSubscriptionName(subscriptionName, t), " ").concat(t('subscription.alert.infoParagraph2'), " ").concat(formatDate(expirationDate), "\n\n").concat(t('subscription.alert.fullAccess'))
        : "".concat(t('subscription.alert.infoParagraph1'), " ").concat(handleSubscriptionName(subscriptionName, t), " ").concat(t('subscription.alert.infoParagraph2'), " ").concat(formatDate(expirationDate));
    return _jsx(AlertComponent, { type: isInfoAlert ? 'info' : 'warning', message: subscriptionMessage, style: theme.infoAlertStyles });
};
export default SubscriptionInfo;
